import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {NotificationService} from '../../notification.service';
import {Level} from '../../../components/shared/notification/Level';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {


  constructor(private notificationService: NotificationService) {
  }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    if (component.canDeactivate())
      return true;
    return new Observable<boolean>(subscriber => {
      const text = {
        header: 'u heeft niet opgeslagen',
        body: 'onopgeslagen wijzigingen gaat verloren',
        ok: 'toch doorgaan',
        level: Level.DANGEROUS
      };
      this.notificationService.confirm(text)
        .then(() => subscriber.next(true))
        .catch(() => subscriber.next(false));
    });
  }
}
